import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.MAIL_CLASSIFICATION;

export const MAIL_CLASSIFICATION_ARRIVAL = createActionName(reducerName, 'MAIL_CLASSIFICATION_ARRIVAL');
export const MAIL_CLASSIFICATION_DEPARTURE = createActionName(reducerName, 'MAIL_CLASSIFICATION_DEPARTURE');
